import { h } from '@stencil/core';
import { i18n } from 'i18n';
import state from 'store';
import { providerConfState } from 'store/providerConf';

interface TermsItems {}

export default function TermsItems({}: TermsItems) {
  return (
    <div class="chat-terms-and-conditions-items-container">
      <div class="term-item">
        <div class="icon">
          <i class="eva-3-icon-edit -eva-3-icon-xsm" />
        </div>
        <p class="eva-3-body-1">{i18n.t.legal.termsAndConditions.item1}</p>
      </div>

      <div class="term-item">
        <div class="icon">
          <i class="eva-3-icon-visa -eva-3-icon-xsm" />
        </div>
        <p class="eva-3-body-1">{i18n.t.legal.termsAndConditions.item2}</p>
      </div>

      <div class="term-item">
        <div class="icon">
          <i class="eva-3-icon-audit -eva-3-icon-xsm" />
        </div>
        <p class="eva-3-body-1">{i18n.t.legal.termsAndConditions.item3}</p>
      </div>

      <div class="term-item -eva-3-mt-xxlg">
        <p class="eva-3-body-1">
          {i18n.t.legal.termsAndConditions.item4}{' '}
          <a href={providerConfState.conf.footer.termsAndConditionLink} target={'_blank'} class="eva-3-link">
            {i18n.t.legal.termsAndConditions.linkTermsAndConditions}
          </a>
        </p>
      </div>
    </div>
  );
}
